import React from 'react';
import { string } from 'prop-types';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { ButtonGroup } from '@tesla/design-system-react';
import { useSelector } from 'react-redux';
import messages from '../messages';
import style from '../../../style.module.scss';
import { slugify } from '../../../utils/common';

const Apply = ({ applyUrl, jobId, query, department }) => {
  const intl = useIntl();
  const isVersion2 = useSelector((state) => state.app.isVersion2);
  const { formatMessage, locale } = intl;

  const trackApply = () => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'careers',
        interaction: 'apply',
        label: `${jobId}-${slugify(department)}`,
      });
    }
  };

  return (
    <>
      {!isVersion2 && (
        <ButtonGroup className={style.ButtonGroup}>
          <a
            className="tds-btn"
            href={applyUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackApply}
          >
            {formatMessage(messages.ApplyForJob)}
          </a>
        </ButtonGroup>
      )}

      {isVersion2 && (
        <ButtonGroup className={style.ButtonGroup}>
          <Link
            to={`/job/apply/${jobId}${query}`}
            onClick={trackApply}
            dangerouslySetInnerHTML={{ __html: formatMessage(messages.ApplyForJob) }}
            className="tds-btn"
            target="_blank"
            rel="noopener noreferrer"
          />
        </ButtonGroup>
      )}

      {locale === 'en-US' && (
        // eslint-disable-next-line react/no-danger
        <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.EVerify) }} />
      )}
    </>
  );
};

Apply.propTypes = {
  jobId: string.isRequired,
  query: string.isRequired,
  applyUrl: string.isRequired,
  department: string.isRequired,
};

export default Apply;
